import { jsxs as c, jsx as a } from "react/jsx-runtime";
import { z as t } from "zod";
import { withManagedProps as b } from "@made-people/managed-props";
import { withZod as d } from "@made-people/react-prop-guard";
import { actionCardDetailStyling as T, actionCardTorontoStyling as j, actionCardAlbertaStyling as x } from "./index-blueprint.es.js";
import { componentWrapperSchema as f, ComponentWrapper as A } from "@made-people/blueprint-component-wrapper";
import { buttonAsLinkSchema as h, ButtonAsLink as u } from "@made-people/blueprint-button";
import { headingSchema as v, Heading as N } from "@made-people/blueprint-heading";
import { badgeSchema as z, Badge as D } from "@made-people/blueprint-badge";
import { mediaSchema as I, Media as L } from "@made-people/blueprint-media";
import { responsiveImageSchema as M, ResponsiveImage as _ } from "@made-people/blueprint-responsive-image";
import "@made-people/blueprint";
const S = t.object({
  variants: t.custom().optional(),
  icon: t.object({
    src: t.string().nullable(),
    alt: t.string().nullable()
  }).optional(),
  heading: v.optional(),
  body: t.string().optional()
}), C = b(
  "ActionDetail",
  d(
    {
      schema: S,
      defaultProps: {
        heading: {
          headingTag: "h4",
          variants: { headingSize: "xs" }
        }
      }
    },
    ({ heading: o, icon: e, body: s, variants: n }) => {
      const i = T.styles(n);
      return /* @__PURE__ */ c("div", { className: i.base, children: [
        (e == null ? void 0 : e.src) && /* @__PURE__ */ a(
          "img",
          {
            className: i.icon,
            src: e.src,
            alt: e.alt ?? ""
          }
        ),
        o && /* @__PURE__ */ a(N, { ...o, className: i.headingWrapper }),
        s && /* @__PURE__ */ a("p", { className: i.body, children: s })
      ] });
    }
  )
), W = t.object({
  variants: t.custom().optional(),
  media: I.optional(),
  heading: v.optional(),
  body: t.string().optional(),
  links: t.union([h, h.array()]).optional(),
  details: t.array(S).optional(),
  layout: f.shape.layout.optional(),
  badge: z.optional()
}), H = b(
  "ActionCardToronto",
  d(
    {
      schema: W,
      defaultProps: {
        media: {
          image: {
            displaySize: {
              mobile: "25vw",
              tablet: "35vw",
              desktop: "50vw"
            }
          }
        }
      }
    },
    ({ heading: o, links: e, media: s, badge: n, body: i, details: m, variants: g, layout: r }) => {
      const l = j.styles(g);
      return /* @__PURE__ */ c(A, { className: l.base, layout: { ...r }, children: [
        /* @__PURE__ */ c("div", { className: l.wrapper, children: [
          (n == null ? void 0 : n.label) && /* @__PURE__ */ a(D, { ...n }),
          s && /* @__PURE__ */ a(L, { ...s, className: l.image }),
          o && /* @__PURE__ */ a(N, { className: l.headingWrapper, ...o }),
          i && /* @__PURE__ */ a(
            "p",
            {
              className: l.body,
              dangerouslySetInnerHTML: { __html: i }
            }
          ),
          e && /* @__PURE__ */ a("div", { className: l.linksWrapper, children: Array.isArray(e) ? e.map((p, y) => /* @__PURE__ */ a(u, { ...p }, `button-${y}`)) : /* @__PURE__ */ a(u, { ...e }) })
        ] }),
        m && m.length > 0 && /* @__PURE__ */ a("div", { className: l.detailsWrapper, children: m.map(
          (p, y) => /* @__PURE__ */ a(C, { ...p }, y)
        ) })
      ] });
    }
  )
), w = t.object({
  variants: t.custom().optional(),
  heading: v.optional(),
  image: M.optional(),
  body: t.string().optional(),
  links: t.union([h, h.array()]).optional(),
  details: t.array(S).optional(),
  layout: f.shape.layout.optional()
}), k = d(
  {
    schema: w,
    defaultProps: {
      heading: {
        headingTag: "h3"
      },
      image: {
        displaySize: {
          mobile: "25vw",
          tablet: "35vw",
          desktop: "50vw"
        }
      }
    }
  },
  ({ heading: o, body: e, image: s, links: n, details: i, variants: m, layout: g }) => {
    const r = x.styles(m);
    return /* @__PURE__ */ c(A, { className: r.base, layout: { ...g }, children: [
      /* @__PURE__ */ c("div", { className: r.wrapper, children: [
        s && /* @__PURE__ */ a("div", { className: r.imageWrapper, children: /* @__PURE__ */ a(_, { ...s, className: r.image }) }),
        /* @__PURE__ */ c("div", { className: r.contentWrapper, children: [
          o && /* @__PURE__ */ a(N, { className: r.headingWrapper, ...o }),
          e && /* @__PURE__ */ a(
            "div",
            {
              className: r.body,
              dangerouslySetInnerHTML: { __html: e }
            }
          ),
          n && /* @__PURE__ */ a("div", { className: r.linksWrapper, children: Array.isArray(n) ? n.map((l, p) => /* @__PURE__ */ a(u, { ...l }, `button-${p}`)) : /* @__PURE__ */ a(u, { ...n }) })
        ] })
      ] }),
      i && i.length > 0 && /* @__PURE__ */ a("div", { className: r.detailsWrapper, children: /* @__PURE__ */ a("div", { className: r.detailsWrapper, children: i.map(
        (l, p) => /* @__PURE__ */ a(C, { ...l }, p)
      ) }) })
    ] });
  }
), P = t.discriminatedUnion("template", [
  W.extend({
    template: t.literal("toronto")
  }),
  w.extend({
    template: t.literal("alberta")
  })
]), B = d(P, (o) => {
  switch (o.template) {
    case "toronto":
      return /* @__PURE__ */ a(H, { ...o });
    case "alberta":
      return /* @__PURE__ */ a(k, { ...o });
    default:
      return null;
  }
}), $ = "toronto", R = t.object({
  templateProps: P.optional()
}), Y = b(
  "ActionCard",
  d(R, (o) => {
    const e = o.templateProps || { template: $ };
    return /* @__PURE__ */ a(B, { ...e });
  })
);
export {
  Y as ActionCard,
  k as ActionCardAlberta,
  H as ActionCardToronto,
  C as ActionDetail,
  B as TemplateSelector,
  w as actionCardAlbertaPropsSchema,
  R as actionCardPropsSchema,
  W as actionCardTorontoPropsSchema,
  S as actionDetailPropsSchema,
  P as templateSelectorSchema
};
//# sourceMappingURL=index.es.js.map
